
import { TableConfig, DataTable } from "@app/interfaces";

export class ConductDetailFormsTableConfig implements DataTable {

    constructor() { }

    static configure(): TableConfig {

        const tableConfig: TableConfig = {
            key: 'items',
            searchPanel: false,
            groupPanel: false,
            canEdit: false,
            showPagination: {
                showPageSizeSelector: false,
                pageSize: 100,
                allowedPageSizes: [10, 20, 100]
            },
            fields: [
                {
                    caption: 'Name',
                    dataField: 'name'
                },
                // {
                //     caption: 'Edit',
                //     width: 60,
                //     cellTemplate: {
                //         id: 'itemsActionButtons',
                //         buttons: [{
                //             icon: 'fa-solid fa-pencil',
                //             name: "Edit",
                //             eventName: "edit",
                //             cssClass: "me-2"
                //         }],
                //     },
                // },
            ]
        };

        return tableConfig;

    }

}